/**
 * An entry's category is its first tag that has a colour set (Einstellungen → Farben).
 * Tags keep the order they were assigned in, so the editor decides which tag that is.
 *
 * @param {string[] | undefined} tag_keys - the entry's tags, in their assigned order
 * @param {Record<string, string> | undefined} tag_colors - { tag_key: color_id } (layout data `entry_tag_colors`)
 * @returns {{ tag_key: string, color_id: string } | null}
 */
export function get_entry_category(tag_keys, tag_colors) {
  if (!tag_keys?.length || !tag_colors) return null;
  for (const tag_key of tag_keys) {
    const color_id = tag_colors[tag_key];
    if (color_id) return { tag_key, color_id };
  }
  return null;
}
